import {useSelector} from "react-redux";
import Modal from "../../../core/Modal/Modal";
import FilterMobile from "./FilterMobile.jsx";
import HistoryFilterMobile from "./HistoryFilterMobile.jsx";
import TournamentInfoMobile from "./TournamentInfoMobile.jsx";
import CreateGameModalMobile from "./CreateRoomMobile.jsx";
import ServerInfoModal from "./ServerInfo.jsx";
import HowToPlayModal from "./HowToPlayModal.jsx";
import SettingsModal from "./SettingsModal.jsx";
import RakeRaceModal from "./RakeRaceModal.jsx";
import ServerBonusInfoModal from "./ServerBonusInfoModal.jsx";
import SafeDynamicComponent from "../SafeDynamicComponent.jsx";

const CombinedModals = {
    FilterMobile: {animated: true, modal: FilterMobile, renderFor: 'mobile'},
    HistoryFilterMobile: {animated: true, modal: HistoryFilterMobile, renderFor: 'mobile'},
    TournamentInfoMobile: {animated: true, modal: TournamentInfoMobile, renderFor: 'mobile'},
    CreateGameModalMobile: {animated: true, modal: CreateGameModalMobile, renderFor: 'mobile'},
    ServerInfoModal: {animated: false, modal: ServerInfoModal, renderFor: 'all'},
    ServerBonusInfoModal: {animated: false, modal: ServerBonusInfoModal, renderFor: 'all'},
    HowToPlay: {animated: false, modal: HowToPlayModal, renderFor: 'all'},
    Settings: {animated: false, modal: SettingsModal, renderFor: 'all'},
    RakeRace: {animated: false, modal: RakeRaceModal, renderFor: 'all'},
};

function GameModal() {
    const isMobile = useSelector(state => state.user.isMobile);
    const activeModalName = useSelector(state => state.lobby.activeModalName);
    const component = CombinedModals[activeModalName];
    if (!component) return;
    const ActiveModal = component.modal;
    return <Modal
        render={component.renderFor === 'mobile' ? isMobile : true}
        animated={component.animated}>
        <SafeDynamicComponent Component={ActiveModal}/>
    </Modal>
}

export default GameModal
